import React from 'react';
import { useAuth } from '../shared/contexts/auth-context';
import { hasPermission } from '../shared/utils/permissions';

const PermissionWrapper = ({ permission, children, fallback = null }) => {
  const { user } = useAuth();

  if (!hasPermission(user, permission)) {
    return fallback || (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default PermissionWrapper;